<template>      
    <router-link v-bind:to="'/'" tag='a' v-on:click.native='Logout' class='customPadding'><span v-on:click='Logout' >Salir</span></router-link>
</template>
<script>
import { eventBus } from '../../main';
export default {  
  data: function () {     
    return {
       
    }
  },
  mounted: function () {        

  },
  methods: {
    Logout: function(){                
        this.$http.get('api/logout').then(response => {                        
            if(response.body.status == 1){                
                this.$router.push('/');	        
                this.$router.go('');	         
            }            
        }, response => {
           eventBus.$emit('errorMsg',response);   
        });        
    },    
  },
  filters: {
     
  },
  computed: {
    
  }
}
</script>

<style scoped>
 
</style>



// WEBPACK FOOTER //
// Logout.vue?4e2cdae5